export default "__VITE_ASSET__DVwD0Jwa__"